module.exports = __webpack_public_path__ + "static/media/redis.616cc1be.svg";